import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../contexts/ThemeContext";
import "./MaXSidebarLogo.css";

const LOGO_LIGHT_THEME = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_01.png`;
const LOGO_DARK_THEME = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_Dark_01.png`;

/**
 * Sidebar header logo: correct contrast for light vs dark app theme.
 */
const MaXSidebarLogo = ({ isOpen, to = "/home", title = "MaX — Home" }) => {
  const { theme } = useTheme();
  const src = theme === "dark" ? LOGO_DARK_THEME : LOGO_LIGHT_THEME;

  return (
    <Link to={to} className="max-sidebar-logo-link" title={title}>
      <img
        src={src}
        alt="MaX Consulting"
        className={`max-sidebar-logo-img ${isOpen ? "max-sidebar-logo-img--open" : "max-sidebar-logo-img--closed"}`}
        width={isOpen ? 220 : 48}
        height={isOpen ? 44 : 38}
        loading="lazy"
        decoding="async"
      />
    </Link>
  );
};

export default MaXSidebarLogo;
